export default "__VITE_ASSET__Cn5UK4dx__"